export const languageElements = {
  items: {
    "form-title": {
      hu: "Felhasználói adatok",
      de: "Benutzer Angaben",
      en: "User settings",
    },
  },
};
